import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, Validators } from '@angular/forms';
import moment from 'moment';
import { ShipmentsCommonApiService } from '@shared-features/services/shipments-common-api.service';
import { BaseComponent } from '@shared/components/base-component/base.component';
import { SectionStateStatus } from '@shared/enums/section-state-status.enum';

@Component({
  selector: 'app-edit-gate-to-gate-dialog',
  templateUrl: './edit-gate-to-gate-dialog.component.html',
  styleUrls: ['./edit-gate-to-gate-dialog.component.scss'],
})
export class EditGateToGateDialogComponent extends BaseComponent implements OnInit {
  form = this.formBuilder.group({
    date: [null, [Validators.required]],
    time: [null, [Validators.required]],
  });

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: { id: number; date: Date },
    private formBuilder: FormBuilder,
    private dialogRef: MatDialogRef<any>,
    private shipmentsCommonApiService: ShipmentsCommonApiService
  ) {
    super();
  }

  ngOnInit(): void {
    if (this.data.date) {
      const momentDate = moment(this.data.date);
      const time = momentDate.format('HH:mm');
      const date = momentDate.toDate();
      this.form.setValue({ date, time } as any);
    }
  }

  handleCancel(): void {
    this.dialogRef.close(null);
  }

  handleConfirm(): void {
    if (this.form.invalid) {
      this.form.markAsTouched();
      return;
    }

    const date = moment(this.form.value.date).format('YYYY-MM-DD');
    const time = this.form.value.time;
    const actionDate = moment(`${date} ${time}`).toDate();
    this.load(
      this.shipmentsCommonApiService.updateGateToGateTime({
        id: this.data.id,
        date: actionDate,
      }),
      { isLoadingTransparent: true }
    ).subscribe((res) => {
      this.dialogRef.close(res);
    });
  }

  protected readonly SectionStateStatus = SectionStateStatus;
}
